<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-field-with-button__container-box"
    [ngClass]="{'common-field-with-button__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-field-with-button__block-header">
      <div class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">{{field.label}}</span>
        @if(field.required){
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
        </div>
      </div>
      @if (field.description) {
        <div class="common-field-with-button__text-description"
          [innerHTML]="field.description"></div>
      }
    </div>
    <div class="common-field-with-button__buttons-container">
      <button class="common-button__text-little-border"
        [disabled]="field.noEditable"
        (click)="generateDocument()">
        <i class="lf-icon-textbooks common-icon__sm"></i>
        <span class="common-button__text-little-title"
        [afTranslate]="'field-type-template.generate-document'">_Generar documento</span>
      </button>
    </div>
    @if (field.evaluatedValue?.documents?.length) {
      <div class="common-field-with-button__items-block">
        @for (document of field.evaluatedValue?.documents; track $index) {
          <div class="common-field-with-button__item-container">
            <div class="common-field-with-button__text-container">
              <div class="common-field-with-button__info-line-container">
                <span class="common-field-with-button__label-text">
                  <span [afTranslate]="'field-type-template.generated-document'">_Documento generado</span>:
                </span>
                <button class="common-button__link"
                  [disabled]="field.noEditable"
                  (click)="downloadDocument(document)">
                  <span class="common-button__link-text">{{document.name}}</span>
                </button>
              </div>
            </div>
            @if ((document.canBeDeleted || !isLanding) && !field.noEditable) {
              <button class="common-field-with-button__button-action"
                pTooltip="{{'common.remove' | afTranslate}}"
                tooltipPosition="top"
                (click)="removeDocument(document)">
                <i class="lf-icon-trash common-icon__md"></i>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
    </div>
  }
</div>
